import React from 'react';
import PropTypes from 'prop-types';
import { ArrowUpward, ArrowDownward } from '@mui/icons-material';
import { Fab } from '@mui/material';

const SortableButtons = ({
  indexUp,
  indexDown,
  index,
  onAnyButtonClick,
  disabled,
}) => {
  const onClick = (fromIdx, toIdx, event) => {
    onAnyButtonClick(fromIdx, toIdx);
    event.stopPropagation();
  };

  return (
    <div className="pr3">
      <span className="pa1">
        <Fab
          size="small"
          color="primary"
          onClick={(e) => onClick(index, indexDown, e)}
          disabled={disabled || index === indexDown}
          disableRipple
        >
          <ArrowUpward />
        </Fab>
      </span>
      <span className="pa1">
        <Fab
          size="small"
          color="primary"
          onClick={(e) => onClick(index, indexUp, e)}
          disabled={disabled || index === indexUp}
          disableRipple
        >
          <ArrowDownward />
        </Fab>
      </span>
    </div>
  );
};

export default SortableButtons;

SortableButtons.defaultProps = {
  disabled: false,
};

SortableButtons.propTypes = {
  indexUp: PropTypes.number.isRequired,
  indexDown: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  onAnyButtonClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};
